// Modals used only by the kitchen screen.
// Each of these modals should be registered in src/kitchen/vue/kitchenVueInit.js
// And the source for each modal should be in src/kitchen/vue/modals
const MODAL_NAMES__KITCHEN = {
    KITCHEN_MENU: 'KitchenMenuModal',
    KITCHEN_ORDER_DETAILS: 'KitchenOrderDetailsModal',
};

module.exports = {
    MODAL_NAMES__KITCHEN,
};
